(function () {
  'use strict';

  function formatMoney(cents) {
    var euros = (parseInt(cents, 10) || 0) / 100;
    return euros.toLocaleString('fr-FR', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
  }

  function track(eventName, payload) {
    try {
      if (typeof window.gtag === 'function') {
        window.gtag('event', eventName, payload);
      } else if (window.dataLayer && typeof window.dataLayer.push === 'function') {
        var dlPayload = Object.assign({ event: eventName }, payload);
        window.dataLayer.push(dlPayload);
      }
    } catch (e) { /* no-op */ }
  }

  function initModal(modal) {
    if (!modal || modal.dataset.makeOfferInit === '1') return;
    modal.dataset.makeOfferInit = '1';

    var body = modal.querySelector('[data-make-offer-body]');
    var form = modal.querySelector('[data-make-offer-form]');
    var successPanel = modal.querySelector('[data-make-offer-success]');
    var priceInput = modal.querySelector('[data-make-offer-price]');
    var qtyInput = modal.querySelector('[data-make-offer-qty]');
    var discountHint = modal.querySelector('[data-make-offer-discount]');
    var errorBox = modal.querySelector('[data-make-offer-error]');
    var submitBtn = modal.querySelector('[data-make-offer-submit]');
    var submitText = modal.querySelector('[data-make-offer-submit-text]');
    var spinner = submitBtn ? submitBtn.querySelector('.make-offer-modal__spinner') : null;

    var formAction = modal.dataset.formAction;
    var productId = modal.dataset.productId;
    var productTitle = modal.dataset.productTitle;
    var productUrl = modal.dataset.productUrl;
    var variantId = modal.dataset.variantId;
    var listPriceCents = parseInt(modal.dataset.listPriceHt, 10) || 0;
    var listPriceMoney = modal.dataset.listPriceMoney || '';
    var maxQty = parseInt(modal.dataset.maxQty, 10) || 9999;
    var currency = modal.dataset.currency || 'EUR';
    var fallbackContactUrl = modal.dataset.fallbackContactUrl || '/pages/contact';

    if (maxQty > 0 && qtyInput) qtyInput.max = maxQty;

    var lastFocusedElement = null;

    function open() {
      lastFocusedElement = document.activeElement;
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      // Reset to form view
      if (body) body.hidden = false;
      if (successPanel) successPanel.hidden = true;
      if (errorBox) { errorBox.hidden = true; errorBox.textContent = ''; }
      if (discountHint) discountHint.hidden = true;
      if (form) form.reset();
      if (qtyInput) qtyInput.value = '1';
      // Focus first input
      setTimeout(function () {
        if (priceInput) priceInput.focus();
      }, 50);
    }

    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus();
      }
    }

    function updateDiscountHint() {
      if (!priceInput || !discountHint || listPriceCents <= 0) return;
      var offer = parseFloat(priceInput.value);
      if (isNaN(offer) || offer <= 0) {
        discountHint.hidden = true;
        return;
      }
      var offerCents = Math.round(offer * 100);
      var diffCents = listPriceCents - offerCents;
      if (diffCents <= 0) {
        discountHint.hidden = true;
        return;
      }
      var pct = Math.round((diffCents / listPriceCents) * 100);
      discountHint.textContent = 'Soit ' + pct + '% sous le prix affiché (' + listPriceMoney + ' HT).';
      discountHint.hidden = false;
    }

    function setLoading(isLoading) {
      if (!submitBtn) return;
      submitBtn.disabled = isLoading;
      if (submitText) submitText.textContent = isLoading ? 'Envoi…' : 'Envoyer mon offre';
      if (spinner) spinner.hidden = !isLoading;
    }

    function showError(html) {
      if (!errorBox) return;
      errorBox.innerHTML = html;
      errorBox.hidden = false;
    }

    function showSuccess() {
      if (body) body.hidden = true;
      if (successPanel) successPanel.hidden = false;
    }

    function buildPayload(formData, offerValue, qtyValue) {
      var offerCents = Math.round(offerValue * 100);
      var totalCents = offerCents * qtyValue;
      var discountPct = listPriceCents > 0
        ? Math.max(0, Math.round(((listPriceCents - offerCents) / listPriceCents) * 100))
        : 0;

      var payload = {
        _subject: 'Nouvelle offre — ' + productTitle + ' — ' + offerValue.toLocaleString('fr-FR') + '€',
        _replyto: formData.get('contact_email') || '',
        _template: 'table',
        _captcha: 'false',
        product_title: productTitle,
        product_url: productUrl,
        product_id: productId,
        variant_id: variantId,
        list_price_ht: listPriceMoney,
        offered_price_ht: offerValue.toLocaleString('fr-FR') + ' €',
        // Montants bruts en centimes : les champs formates ci-dessus sont
        // ambigus des 1 000 € (« 2.250 € » se relit 2,25). Le flow n8n doit
        // lire ces deux-la, les autres ne servent qu'a l'affichage humain.
        list_price_cents: String(listPriceCents),
        offered_price_cents: String(offerCents),
        quantity: String(qtyValue),
        total_offered_ht: formatMoney(totalCents) + ' €',
        discount_percent: discountPct + ' %',
        contact_name: formData.get('contact_name') || '',
        contact_company: formData.get('contact_company') || '',
        contact_email: formData.get('contact_email') || '',
        contact_phone: formData.get('contact_phone') || '',
        delivery_city: formData.get('delivery_city') || '',
        message: formData.get('message') || '(aucun)',
        website: formData.get('website') || '',
        attribution: window.RedeskDL && window.RedeskDL.attribution ? window.RedeskDL.attribution() : {}
      };
      return { payload: payload, offerCents: offerCents, totalCents: totalCents, discountPct: discountPct };
    }

    function handleSubmit(event) {
      event.preventDefault();
      if (!form || !formAction) return;
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var formData = new FormData(form);
      var offerValue = parseFloat(priceInput.value);
      var qtyValue = parseInt(qtyInput.value, 10) || 1;

      if (isNaN(offerValue) || offerValue <= 0) {
        showError('Indiquez un prix valide.');
        priceInput.focus();
        return;
      }

      if (errorBox) errorBox.hidden = true;
      setLoading(true);

      var built = buildPayload(formData, offerValue, qtyValue);

      track('make_offer', {
        product_id: productId,
        product_title: productTitle,
        variant_id: variantId,
        list_price: listPriceCents / 100,
        offered_price: offerValue,
        quantity: qtyValue,
        total_value: built.totalCents / 100,
        discount_percent: built.discountPct,
        currency: currency
      });

      fetch(formAction, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(built.payload)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          setLoading(false);
          showSuccess();
        })
        .catch(function () {
          setLoading(false);
          var mailtoSubject = encodeURIComponent('Offre pour ' + productTitle);
          var mailtoBody = encodeURIComponent(
            'Prix proposé (HT) : ' + offerValue + ' €\n' +
            'Quantité : ' + qtyValue + '\n' +
            'Produit : ' + productUrl + '\n' +
            'Message : ' + (formData.get('message') || '')
          );
          showError(
            'L\'envoi a échoué. <a href="' + fallbackContactUrl + '?subject=' + mailtoSubject +
            '&body=' + mailtoBody + '">Contactez-nous directement</a>.'
          );
        });
    }

    // Event bindings
    modal.querySelectorAll('[data-make-offer-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    if (priceInput) {
      priceInput.addEventListener('input', updateDiscountHint);
    }

    if (form) {
      form.addEventListener('submit', handleSubmit);
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        close();
      }
    });

    // Open handler — global
    document.querySelectorAll('[data-make-offer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        track('make_offer_open', {
          product_id: productId,
          product_title: productTitle
        });
        open();
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-make-offer-root]').forEach(initModal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
